var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"choose-img rounded-lg elevation-3",class:_vm.circle ? 'rounded-circle' : 'rounded-lg',attrs:{"width":_vm.size,"height":_vm.size,"src":_vm.imageSrc}})}
var staticRenderFns = []

export { render, staticRenderFns }